import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import LogoSection from '../LogoSection';

import ProfileSection from './ProfileSection';

const useStyles = makeStyles()((theme) => ({
  grow: {
    flexGrow: 1,
  },
  boxContainer: {
    width: '228px',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      width: 'auto',
    },
  },
}));

const Header = () => {
  const { classes } = useStyles();

  return (
    <>
      <div className={classes.boxContainer}>
        <Box
          component="span"
          sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}
        >
          <LogoSection />
        </Box>
      </div>

      <div className={classes.grow} />

      <ProfileSection />
    </>
  );
};

export default Header;
